/* eslint-disable consistent-return */
import api from 'services/api';
import { toast } from 'react-toastify';
import axios from 'axios';
import { th } from 'date-fns/locale';

export const requestGetAccessToken = async () => {
  const req = axios.create({
    headers: {
      'Access-Control-Allow-Origin': '*',
      'Accept-Language': 'pt-BR',
      client_id: process.env.REACT_APP_CLIENT_ID,
    },
    baseURL: process.env.REACT_APP_API_URL_OAUTH,
  });

  const header = {
    'Content-Type': 'application/json',
    'Accept-Language': 'pt-BR',
    Authorization: process.env.REACT_APP_SIGNIN_AUTHORIZATION,
  };

  const parameters = {
    method: 'POST',
    headers: header,
  };

  const body = {
    grant_type: 'client_credentials',
  };

  let access_token = '';

  try {
    const response = await req.post('oauth/access-token', body, parameters);
    access_token = response.data.access_token;
  } catch (error) {
    const erro = error.response;

    if (erro) {
      const { message } = error.response.data;

      if (error.response.status !== 401) {
        toast.error(message);
      }
    } else if (error.response.status !== 401) {
      toast.error('Ocorreu um erro interno na aplicação');
    }
  }

  return access_token;
};

export const validationToken = async (token, userId) => {
  const headers = {
    access_token: await requestGetAccessToken(),
  };

  const bodyToken = {
    token,
  };

  let success;

  try {
    await api.post(
      `industrial/customer/v1/users/${userId}/validations`,
      bodyToken,
      {
        headers,
      }
    );
    success = true;
  } catch (error) {
    toast.error(
      error?.response?.data?.message ?? 'Ocorreu um erro interno na aplicação'
    );
    success = false;
  }

  return success;
};

export const sendToken = async (contact, userId, contactId = null) => {
  const headers = {
    access_token: await requestGetAccessToken(),
  };
  const bodyToken = {
    tokenType: 'MFA',
    contactId: contact?.contactId || contactId,
    url: null,
  };

  let success;

  try {
    await api.post(`industrial/customer/v1/users/${userId}/tokens`, bodyToken, {
      headers,
    });
    if (contact?.contact) {
      toast.warn(`Enviamos um código de verificação para ${contact?.contact}`);
    } else if (contactId) {
      toast.warn(`Reenviamos um código de verificação`);
    }
    success = true;
  } catch (error) {
    toast.error(
      error?.response?.data?.message ?? 'Ocorreu um erro interno na aplicação'
    );
    success = false;
  }

  return success;
};

const requestUserContacts = async (
  userId,
  data,
  mainTrue = false,
  contact = ''
) => {
  try {
    let params = mainTrue ? '&main=true' : '';
    if (contact.trim().length > 0) {
      params += `&contact=${contact}`;
    }
    const response = await api.get(
      `industrial/customer/v1/users/${userId}/contacts?_limit=10000${params}`
    );

    const resposeData = { ...data, contacts: response.data, userId };
    return resposeData;
  } catch (error) {
    const erro = error.response;

    if (erro) {
      const { message } = error.response.data;

      if (error.response.status !== 401) {
        toast.error(message);
      }
    } else if (error.response.status !== 401) {
      toast.error('Ocorreu um erro interno na aplicação');
    }
  }
};

export const requestGetUser = async (email) => {
  const headers = {
    access_token: await requestGetAccessToken(),
  };
  const params = {
    login: email,
    'is-active': true,
    _limit: 1,
    _offset: 0,
  };

  try {
    const response = await api.get('industrial/customer/v1/users', {
      headers,
      params,
    });

    const mainTrue = true;

    if (response.data.length) {
      const { userId } = response.data[0];
      const responseUserContacts = await requestUserContacts(
        userId,
        response.data[0],
        mainTrue,
        email
      );

      console.log({ response, responseUserContacts });
      return responseUserContacts;
    }
    toast.error('Nenhum cpf/cnpj encontrado');
  } catch (error) {
    const erro = error.response;
    if (erro) {
      const { message } = error.response.data;

      if (error.response.status !== 401) {
        toast.error(message);
      }
    } else if (error.response.status !== 401) {
      toast.error('Ocorreu um erro interno na aplicação');
    }
  }
};

export const requestGetUserById = async (userId, login) => {
  try {
    const mainTrue = true;
    const responseUserContacts = await requestUserContacts(
      userId,
      [],
      mainTrue,
      login
    );
    if (!userId && responseUserContacts === undefined) {
      throw new Error('Erro ao carregar os contatos!');
    }
    return responseUserContacts;
  } catch (error) {
    const erro = error.response;
    if (erro) {
      const { message } = error.response.data;

      if (error.response.status !== 401) {
        toast.error(message);
      }
    } else if (error.response.status !== 401) {
      toast.error('Ocorreu um erro interno na aplicação');
    }
  }
};
